var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-block"},[_c('vue-apex-charts',{attrs:{"type":"area","options":_vm.chartOptions,"series":_vm.series,"width":"100%","height":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }